import { Stack } from "@mui/material";
import { CbhIcon, Text } from "@src/appV2/redesign/system/ui-components";
import pluralize from "pluralize";

interface NewsFeedItemCommentsCountProps {
  count: number;
  showIcon?: boolean;
  includeText?: boolean;
}

export function NewsFeedItemCommentsCount(props: NewsFeedItemCommentsCountProps) {
  const { count, showIcon = false, includeText = false } = props;

  return (
    <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
      {showIcon && <CbhIcon size="small" aria-label="comments" type="chat" />}
      <Text>
        {count}
        {includeText ? pluralize(" comment", count) : ""}
      </Text>
    </Stack>
  );
}
